var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"todos-container"},[(_vm.store.todos.isLoading)?_c('div',{staticClass:"loading"},[_c('loading')],1):_vm._e(),_vm._l((_vm.store.todos.todos),function(todo){return _c('todo',{key:todo.id,attrs:{"todo":todo}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }